<template>
  <div v-if="show" class="modal-overlay" @click.self="close">
    <div class="modal-content" :class="classesNames">
      <header class="modal-header">
        <slot name="header">Titre par défaut</slot>
        <button class="close-btn" @click="close">✖</button>
      </header>
      <section class="modal-body">
        <slot>Contenu par défaut</slot>
      </section>
      <footer class="modal-footer">
        <slot name="footer">
          <button @click="close">Fermer</button>
        </slot>
      </footer>
    </div>
  </div>
</template>

<script setup>
import { defineProps, defineEmits } from "vue"

const props = defineProps({
  show: { type: Boolean, required: true },
  classesNames: { type: String },
})

const emit = defineEmits(["update:show", "closed"])

function close() {
  emit("update:show", false);
  emit("closed");
}
</script>

<style scoped>
.modal-header {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 15px;
}
.modal-footer {
  display: flex;
  flex-direction: row;
  justify-content: end;
  margin-top: 20px;
}
.modal-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0,0,0,0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
}
.modal-content {
  background: white;
  padding: 1.5rem;
  border-radius: 0.5rem;
  min-width: 300px;
  /*max-width: 500px;*/
}
.modal-content.modal-lg {
  width: 90%;
}
.modal-content.modal-wide {
  width: 90%;
  height: 90vh;
  display: flex;
  flex-direction: column;
}
.modal-content.modal-fullscreen {
    width: 100%;
    height: 100vh;
    display: flex;
    flex-direction: column;
}
.modal-content .modal-body {
  flex: 1;
  overflow: hidden;
  overflow-y: auto;
}
.close-btn {
  border: none;
  background: none;
  cursor: pointer;
  font-size: 1.2rem;
}
</style>
